import { Component, computed, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { StorageProvider } from '../../providers/storage/storage';
import { ExternalLinkService } from '../../utils/external-link.service';

@Component({
  selector: 'footer-new-version',
  templateUrl: './footer-new-version.component.html',
  styleUrls: ['./footer-new-version.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
})
export class FooterNewVersionComponent {
  private storageProvider: StorageProvider = inject(StorageProvider);
  private externalLinkService: ExternalLinkService = inject(ExternalLinkService);
  version: string = environment.appVersion;

  isMntDiffus = input.required<boolean>();
  showFooter = signal(true);

  displayFooter = computed(() => {
    return this.isMntDiffus() && this.showFooter();
  });

  constructor() {
    this.initFooter().then();
  }

  openReleaseNotePage() {
    let url = 'https://docs.google.com/presentation/d/1o8_aiQ6Co8ljhnVNw6QBHdQbX8BJrw1JVIFgHL4zTSY/edit?usp=drive_link';
    this.externalLinkService.ouvrirLien(url);
  }

  async initFooter() {
    let lastReleaseNoteVersionClosed = await this.storageProvider.get('last_release_note_version_closed', false);
    this.showFooter.set(lastReleaseNoteVersionClosed !== this.version);
  }

  async closeFooter() {
    this.showFooter.set(false);
    await this.storageProvider.set('last_release_note_version_closed', this.version, false);
  }
}
